<template>
  <form v-loading="loading" :class="[$style.registerWrap]">
    <AccountNav></AccountNav>
    <form :class="[$style.inputForm]" @submit.prevent="handleSubmit">
      <el-input
        v-model="params.user_id"
        prefix-icon="el-icon-user"
        :class="[$style.inputRegister]"
        :placeholder="$t('account_form.id_place')"
      />
      <el-input
        v-model="params.password"
        prefix-icon="el-icon-lock"
        :class="[$style.inputRegister]"
        :placeholder="$t('account_form.pw_place')"
        type="password"
      />
      <el-input
        v-model="params.confirm_password"
        prefix-icon="el-icon-circle-check"
        :class="[$style.inputRegister]"
        :placeholder="$t('account_form.confirm_pw')"
        type="password"
      />
      <el-input
        v-model="params.user_name"
        prefix-icon="el-icon-s-custom"
        :class="[$style.inputRegister]"
        :placeholder="$t('account_form.name_place')"
      />
      <el-input
        v-model="params.email_address"
        prefix-icon="el-icon-message"
        :class="[$style.inputRegister]"
        :placeholder="$t('account_form.email_place')"
      />
      <template v-for="list in config.terms">
        <div
          v-if="list.use_signup === 'Y'"
          :key="list.type"
          :class="[$style.termsWrap]"
        >
          <div>{{ fromPairs(constants.service.term_types)[list.type] }}</div>
          <div :class="[$style.contentWrap]" :v-html="list.content"></div>
          <label>
            <input v-model="check_list" type="checkbox" :value="list.type" />
            <span :class="[$style.checkText]">{{
              $t('account_form.agree')
            }}</span>
          </label>
        </div>
      </template>

      <label v-if="c_use_signup.length">
        <input v-model="check_all" type="checkbox" @click="checkAll" />
        <span :class="[$style.checkText]">{{
          $t('account_form.all_agree')
        }}</span>
      </label>

      <el-button
        :class="[$style.registerButton]"
        native-type="submit"
        :disabled="!c_check_terms"
        round
        >{{ $t('sign_up') }}</el-button
      >
    </form>
  </form>
</template>
<script>
import { createMember } from '@apis/member'
import AccountNav from '@components/AccountNav'
import fromPairs from 'lodash/fromPairs'
import _ from 'lodash'
import { mapState } from 'vuex'
export default {
  components: { AccountNav },
  data() {
    return {
      params: {},
      loading: false,
      check_list: [],
      check_all: false,
      list_length: '',
    }
  },
  computed: {
    ...mapState('common', { config: (state) => state.config }),
    ...mapState('common', { constants: (state) => state.constants }),
    c_is_required_list() {
      return _.chain(this.config.terms)
        .filter((data) => data.use_signup === 'Y')
        .filter((data) => data.is_required === 'Y')
        .map((data) => {
          return data.type
        })
        .value()
    },
    c_use_signup() {
      return _.chain(this.config.terms)
        .filter((data) => data.use_signup === 'Y')
        .map((data) => {
          return data.type
        })
        .value()
    },
    c_check_terms() {
      return _.every(
        this.c_is_required_list,
        (service) => this.check_list.indexOf(service) !== -1
      )
    },
  },
  watch: {
    check_list: {
      handler(val, oldVal) {
        if (val.length < oldVal.length) {
          this.check_all = false
        }
        if (val.length === this.c_use_signup.length) {
          this.check_all = true
        }
      },
      deep: true,
    },
  },
  methods: {
    handleSubmit() {
      this.loading = true

      createMember(this.params)
        .then(() => this.$router.push({ name: 'home' }))
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    checkAll() {
      this.check_list = []
      if (!this.check_all) {
        for (var i = 0; i < this.c_use_signup.length; i++) {
          this.check_list.push(this.c_use_signup[i])
        }
      }
    },
    fromPairs,
  },
}
</script>

<style lang="scss" module>
@import '@design';

.registerWrap {
  box-sizing: border-box;
  max-width: 500px;
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom: 100px;
  border: 1px solid #eee;
  box-shadow: 2px 2px 4px #dee1e7;
}
.registerTitle {
  margin: 0;
  margin-bottom: 20px;
  font-size: 30px;
}
.inputForm {
  padding: 20px;
  background-color: white;
}
.inputRegister {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 40px;
  border-radius: 3px;
  transition: box-shadow 0.1s ease, -webkit-box-shadow 0.1s ease;
}
.registerLink {
  margin-right: 10px;
  margin-bottom: 30px;
  cursor: pointer;
}
.registerButton {
  width: 100%;
  margin: 10px 0;
  font-size: 16px;
  color: #fff !important;
  cursor: pointer;
  background-color: #63bc90 !important;
  border-radius: 4px !important;
  transition: transform 0.4s ease-out;
}

.el-button.is-round {
  border-radius: 4px;
}

.registerButton:hover {
  background: #4eaa7c;
}

.termsWrap {
  padding: 15px;
  margin-bottom: 20px;
  color: #111;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.contentWrap {
  height: 230px;
  padding: 20px;
  margin: 10px 0;
  overflow-y: auto;
  font-family: 'Malgun Gothic';
  font-size: 14px;
  line-height: 1.6;
  color: rgb(51, 51, 51);
  letter-spacing: -1px;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
}
.checkText {
  margin-left: 5px;
}
</style>
